import { createTheme } from '@mui/material/styles';

export const portalTheme = (dir) => createTheme({
    palette: {
        // تغيير اللون الأساسي إلى اللون الأزرق الغامق من الشعار
        primary: {
            main: "#0B3C5D"  // تم التغيير من #010000 إلى #0B3C5D (أزرق غامق)
        },

        // تغيير اللون الثانوي إلى اللون الذهبي من الشعار
        secondary: {
            main: "#D9B310"  // تم التغيير من #FEFEFE إلى #D9B310 (ذهبي)
        },

        colorA: {
            light: '#1A5F8C',
            main: "#0B3C5D",  // تم التغيير إلى اللون الأزرق الأساسي
            dark: '#051E30',
        },

        colorB: {
            light: '#F3D351',
            main: "#D9B310",  // تم التغيير إلى اللون الذهبي
            dark: '#A98A0C',
        },

        colorC: {
            light: '#FFFFFF',
            main: "#FEFEFE",
            dark: '#F0F0F0',
        },

        colorD: {
            light: '#1A5F8C',
            main: "#0B3C5D",  // تم التغيير من #FE4545 إلى #0B3C5D (لتوحيد الألوان)
            dark: '#051E30',
        },

        background: {
            default: '#F7F9FB',  // تم التغيير لإضافة لمسة زرقاء خفيفة
            paper: '#FFFFFF',
        },
    },
    direction: dir,
    components: {
        // Name of the component
        MuiButton: {
            styleOverrides: {
                // زر أساسي (أزرق)
                b1: {
                    background: "#0B3C5D",  // تم التغيير من #FE4545 إلى #0B3C5D
                    color: "#FFFFFF !important",
                    "&:active": {
                        background: "#051E30"  // تم التغيير إلى ظل أغمق من الأزرق
                    },
                    "&.Mui-disabled": {
                        opacity: .7
                    },
                    '&:hover': { background: '#1A5F8C' }  // تم التغيير إلى ظل أفتح من الأزرق
                },

                // زر ثانوي (ذهبي بحدود)
                b2: {
                    background: "transparent",
                    color: "#D9B310",  // تم التغيير من #FE4545 إلى #D9B310
                    borderRadius: "5px",
                    border: "1px solid #D9B310",  // تم تحديث لون الحدود
                    "&:active": {
                        background: "#A98A0C",  // ظل أغمق من الذهبي
                        color: "#FFFFFF"
                    },
                    "&.Mui-disabled": {
                        opacity: .7
                    },
                    '&:hover': {
                        background: '#D9B310',
                        color: "#FFFFFF"
                    }
                },

                // زر الرفع
                upload: {
                    background: "transparent",
                    color: "#0B3C5D",  // تم التغيير من #FE4545 إلى #0B3C5D
                    borderRadius: "5px",
                    border: "1px solid #0B3C5D",  // تم تحديث لون الحدود
                    "&:active": {
                        background: "#051E30",  // ظل أغمق من الأزرق
                        color: "#FFFFFF"
                    },
                    "&.Mui-disabled": {
                        opacity: .7
                    },
                    '&:hover': {
                        background: '#D9B310', // الذهبي عند التحويم
                        color: "#FFFFFF",
                        border: "1px solid #D9B310",
                        borderRadius: "20px",
                    }
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: {
                    fontFamily: dir === 'rtl' && 'ArabicBlack',
                    color: "#0B3C5D"  // إضافة لون النص الافتراضي
                },
                h2: {
                    fontFamily: dir === 'rtl' && 'ArabicBlack',
                    color: "#0B3C5D"  // إضافة لون النص الافتراضي
                },
                h3: {
                    fontFamily: dir === 'rtl' && 'ArabicBlack',
                    color: "#0B3C5D"  // إضافة لون النص الافتراضي
                },
                h4: {
                    fontFamily: dir === 'rtl' && 'ArabicBold',
                    color: "#0B3C5D"  // إضافة لون النص الافتراضي
                },
                h5: {
                    fontFamily: dir === 'rtl' && 'ArabicRegualr',
                    color: "#0B3C5D"  // إضافة لون النص الافتراضي
                },
                h6: {
                    fontFamily: dir === 'rtl' && 'ArabicRegualr',
                    color: "#0B3C5D"  // إضافة لون النص الافتراضي
                },
                subtitle1: {
                    fontFamily: dir === 'rtl' && 'ArabicRegualr'
                },
                subtitle2: {
                    fontFamily: dir === 'rtl' && 'ArabicRegualr'
                },
                body1: {
                    fontFamily: dir === 'rtl' && 'ArabicRegualr'
                },
                body2: {
                    fontFamily: dir === 'rtl' && 'ArabicRegualr'
                },
            }
        },
        MuiPaper: {
            styleOverrides: {
                p1: {
                    alignItems: 'center',
                    marginLeft: '31px',
                    padding: 40,
                    justifyContent: 'space-between',
                    backgroundColor: '#F7F9FB',  // تم تعديله ليتناسب مع لون الخلفية
                    borderRadius: '20px 0px 0px 20px',
                    boxShadow: '0px 10px 30px rgba(11, 60, 93, 0.1)',  // تم تحديث لون الظل
                },
                p2: {
                    marginLeft: '31px',
                    padding: '40px 20px',
                    minHeight: 172,
                    justifyContent: 'space-between',
                    borderRadius: '20px 0px 0px 20px',
                    marginTop: 100,
                },
                p3: {
                    background: '#F7F9FB',  // تم تعديله ليتناسب مع لون الخلفية
                    margin: '64px 49px',
                    padding: '17px'
                },
                p4: {
                    p: { xs: 1, md: 3 },
                    minHeight: 180,
                    flexGrow: 1,
                    background: "linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)",
                    borderRadius: 4,
                    boxShadow: "0 8px 32px 0 rgba(11, 60, 93, 0.10)",
                    border: "1px solid #e9ecef",
                    mb: 3,
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    background: '#FFFFFF',
                    '&.Mui-error': {
                        color: '#D9B310', // الذهبي عند الخطأ
                    }
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    background: "#FFFFFF",
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        color: '#D9B310', // الذهبي الخاص بالثيم
                        fontWeight: 600,
                        letterSpacing: 0.2,
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    border: "unset",
                    borderRadius: '10px',
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#D9B310', // الذهبي عند الخطأ
                    },
                }
            }
        },
        // إضافة ظل خفيف لعناصر الكارد والورق
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 4px 20px rgba(11, 60, 93, 0.08)',
                    borderRadius: '12px',
                }
            }
        },
        popoverPaper: {
            width: '100%',
            height: '100%',
            maxHeight: 'unset',
            maxWidth: 'unset',
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    fontFamily: dir === 'rtl' && 'ArabicRegualr',
                    fontWeight: 500,
                },
                standardError: {
                    backgroundColor: '#fff3f3',
                    color: '#B71C1C',
                    border: '1px solid #D9B310',
                },
                standardSuccess: {
                    backgroundColor: '#f8fafc',
                    color: '#0B3C5D',
                    border: '1px solid #D9B310',
                },
                standardWarning: {
                    backgroundColor: '#fffbe6',
                    color: '#D9B310',
                    border: '1px solid #D9B310',
                },
                standardInfo: {
                    backgroundColor: '#f8fafc',
                    color: '#0B3C5D',
                    border: '1px solid #0B3C5D',
                },
                filledError: {
                    backgroundColor: '#D9B310',
                    color: '#0B3C5D',
                },
                filledSuccess: {
                    backgroundColor: '#0B3C5D',
                    color: '#fff',
                },
                filledWarning: {
                    backgroundColor: '#D9B310',
                    color: '#fff',
                },
                filledInfo: {
                    backgroundColor: '#0B3C5D',
                    color: '#fff',
                },
            }
        },
    },
});